import { Button } from "components/styleguide";
import DateRenderer from "components/DateRenderer";
import { ITContractApprovalStatus } from "enums/ITContractApprovalStatus";
import { ForumITContractItemResponseModel, ForumITContractResponseModel } from "generated/api";
import { t } from "i18next";
import { buildColumn } from "utils/columnUtils";

import ItContractApprovalStatus from "./ItApprovalStatus";

export const getContractColumns = (
  editContract: (record: ForumITContractItemResponseModel) => void,
  contractApproval: ForumITContractResponseModel,
) => [
  {
    title: t("Due date"),
    dataIndex: "dueDate",
    render: (date: string) => date && <DateRenderer date={date} />,
  },
  {
    title: t("item"),
    dataIndex: "item",
  },
  {
    title: t("responsible"),
    dataIndex: "responsible",
  },
  {
    dataIndex: "id",
    width: "5%",
    render: (_: number, record: ForumITContractItemResponseModel) => (
      <Button
        disabled={contractApproval.status === ITContractApprovalStatus.Approved}
        onClick={() => editContract(record)}
      >
        {t("Edit") as string}
      </Button>
    ),
  },
];

export const getApprovalColumns = () => [
  buildColumn(t("Current status"), "status", {
    render: (status: string) => <ItContractApprovalStatus status={status} />,
  }),
  buildColumn(t("Decision made by"), "decisionMadeByName"),
  buildColumn(t("Decision made on"), "decisionMadeOnDate", {
    render: (decisionMadeOnDate: string) => decisionMadeOnDate && <DateRenderer date={decisionMadeOnDate} />,
  }),
];
